var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('v-btn',{attrs:{"color":"primary","outlined":"","small":"","block":_vm.block}},[_vm._v(_vm._s(_vm.$t("Paid")))]):_c('v-btn',{attrs:{"color":"error","outlined":"","small":""}},[_vm._v(_vm._s(_vm.$t("label.unpaid")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }